import $api from '@/assets/js/ajax'
// 基本模块
const provinceModule = {
  state: {
    provinceList: []
  },
  mutations: {
    setProvince: (state, data) => {
      state.provinceList = data
    }
  },
  actions: {
    getProvince: ({commit}) => {
      return new Promise(resolve => {
        $api.getProvince(res => {
          commit('setProvince', res)
          resolve(res)
        })
      })
    }
  }
}

export default provinceModule



// WEBPACK FOOTER //
// ./src/store/province.js